// extracted by mini-css-extract-plugin
module.exports = {"button":"SubmitButton_button__2y5IZ"};